import './GlobalStyle.scss';
import '@assets/image/fontawesome-free-6.0.0-web/css/all.min.css';

function GlobalStyle({ children }) {
  return children;
}

export default GlobalStyle;
